import { SimpleListEntity, SimpleListEntityResponse } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'

export interface AdditionlInfoFilterInfo {
    entity: SimpleListEntity
    async: boolean
}

class AdditionalInfoMapping {
    selectHealthManagementArea: AdditionlInfoFilterInfo = { entity: SimpleListEntity.HEALTH_MANAGEMENT_AREA, async: false }
    selectDepartment: AdditionlInfoFilterInfo = { entity: SimpleListEntity.DEPARTMENT, async: false }
    selectPersonnel: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PERSONNEL, async: false }
    selectCaseType: AdditionlInfoFilterInfo = { entity: SimpleListEntity.CASE_TYPE, async: false }
    selectRegime: AdditionlInfoFilterInfo = { entity: SimpleListEntity.REGIME, async: false }
    selectPriority: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PRIORITY, async: false }
    selectCenter: AdditionlInfoFilterInfo = { entity: SimpleListEntity.CENTER, async: false }
    selectPhysicianPetitioner: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PETITIONER, async: false }
    selectStatusCase: AdditionlInfoFilterInfo = { entity: SimpleListEntity.CASE_STATE, async: false }
    selectAttachmentFormat: AdditionlInfoFilterInfo = { entity: SimpleListEntity.ATTACHMENT_SUPPORTED_MIME_TYPES, async: false }
    selectAttachmentType: AdditionlInfoFilterInfo = { entity: SimpleListEntity.ATTACHMENT_TYPE, async: false }
    selectVirtualShelf: AdditionlInfoFilterInfo = { entity: SimpleListEntity.VIRTUAL_SHELF, async: false }
    selectSampleTag: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SAMPLE_TAG, async: false }
    selectSampleType: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SAMPLE_TYPE, async: false }
    selectFixer: AdditionlInfoFilterInfo = { entity: SimpleListEntity.FIXER, async: false }
    selectSampleProcess: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SAMPLE_PROCESS, async: false }
    selectTopographicCode: AdditionlInfoFilterInfo = { entity: SimpleListEntity.TOPOGRAPHIC_CODE, async: true }
    multiselectTopographicCode: AdditionlInfoFilterInfo = { entity: SimpleListEntity.TOPOGRAPHIC_CODE, async: true }
    selectMorphologicCode: AdditionlInfoFilterInfo = { entity: SimpleListEntity.MORPHOLOGIC_CODE, async: true }
    multiselectMorphologicCode: AdditionlInfoFilterInfo = { entity: SimpleListEntity.MORPHOLOGIC_CODE, async: true }
    selectProcedure: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PROCEDURE, async: false }
    selectMostLikelyMorphologicCode: AdditionlInfoFilterInfo = { entity: SimpleListEntity.MOST_LIKELY_MORPHOLOGIC_CODE, async: true }
    selectStatusSample: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SAMPLE_STATES, async: false }
    selectCodification: AdditionlInfoFilterInfo = { entity: SimpleListEntity.MORPHOLOGIC_CODE, async: true }
    selectGender: AdditionlInfoFilterInfo = { entity: SimpleListEntity.GENDER, async: false }
    selectValuableConceptURV: AdditionlInfoFilterInfo = { entity: SimpleListEntity.VALUABLE_CONCEPT_OF_TYPE_URV, async: false }
    selectValuableConceptUCL: AdditionlInfoFilterInfo = { entity: SimpleListEntity.VALUABLE_CONCEPT_OF_TYPE_UCL, async: false }
    selectProtocol: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PROTOCOL, async: false }
    multiselectProtocol: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PROTOCOL, async: false }
    selectProcessor: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PROCESSOR, async: false }
    selectMicrotome: AdditionlInfoFilterInfo = { entity: SimpleListEntity.MICROTOME, async: false }
    selectPortionState: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PORTION_STATE, async: false }
    selectPortionType: AdditionlInfoFilterInfo = { entity: SimpleListEntity.PORTION_TYPE, async: false }
    selectStatusRequest: AdditionlInfoFilterInfo = { entity: SimpleListEntity.REQUEST_STATE, async: false }
    selectSubportionStatus: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SUBPORTION_STATE, async: false }
    selectSubportionType: AdditionlInfoFilterInfo = { entity: SimpleListEntity.SUBPORTION_TYPE, async: false }
    selectAssayGroup: AdditionlInfoFilterInfo = { entity: SimpleListEntity.ASSAYGROUP, async: false }
    selectAssay: AdditionlInfoFilterInfo = { entity: SimpleListEntity.ASSAY, async: false }
    selectPatientIdentifier = null
    selectUnitTime = { entity: SimpleListEntity.PATIENT_AGE, async: false }
}
export const additionalInfoMapping = new AdditionalInfoMapping()

export interface ScientificAnalysisFilterPanelSelectEntityState {
    entities: SimpleListEntityResponse[]
    asyncSearch: boolean
}
export const initialScientificAnalysisFilterPanelSelectEntityState =
    (): ScientificAnalysisFilterPanelSelectEntityState => ({
        entities: [],
        asyncSearch: false
    })
